import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { earningsApi } from '@/api/su/earnings';
import type { IEarnings, IThunkAPI } from '@/store/types';
import { IEarningsInitialState } from '@/store/types';

export const initialState: IEarningsInitialState = {
  earnings: {
    registered: 0,
    graduated: 0,
    completed: 0,
  },
};

export const getMyEarningsById = createAsyncThunk<IEarnings, { userId: number; campaignId: number }, IThunkAPI>(
  'get/myEarnings',
  async ({ userId, campaignId }, thunkAPI) => {
    try {
      const response = await earningsApi.getMyEarningsById(userId, campaignId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const earningsSlice = createSlice({
  name: 'myEarnings',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getMyEarningsById.fulfilled, (state, action) => {
      state.earnings = action.payload;
    });
  },
});

export default earningsSlice.reducer;
